<div class="my-overlay" *ngIf="showOverlay">
    <div class="fa-6x">
        <i class="fas fa-spinner fa-pulse" aria-hidden="true"></i>
    </div>
</div>